import { h, render } from 'preact'
import { isEmptyObject } from './modules/utilities.js'
import { SG1Logs } from './modules/logs.js'

export const orchestrator = (data, config) => {
    try {
        // Check si la config existe
        if (config[data.id] === undefined) throw (`${data.id} n'est pas configuré`)

        // Check si les données parents ne sont pas vides
        if ((isEmptyObject(data) || (data.zones[0].data && isEmptyObject(data.zones[0].data))) && config[data.id].noData !== true) throw (`${data.id} données manquantes`)

        // Check si les données enfants spécifiées dans 'check' sont présentes
        if (config[data.id].check !== undefined && config[data.id].check.length > 0) {
            for (const key of config[data.id].check) {
                if (data.zones[0].data[key] !== undefined) {
                    const keyData = data.zones[0].data[key]
                    if (Array.isArray(keyData) && data.zones[0].data[key].length === 0) throw (`${config[data.id].elementId}: ${key} vide`)
                    if (typeof keyData === 'object' && !Array.isArray(keyData) && isEmptyObject(data.zones[0].data[key])) throw (`${config[data.id].elementId}: ${key} vide`)
                    if (typeof keyData === 'string' && data.zones[0].data[key] === '') throw (`${config[data.id].elementId}: ${key} vide`)
                } else {
                    throw (`${key} non définie`)
                }
            }
        }

        // Render du composant
        if (data.id === data.zones[0].id) {
            let Component = config[data.id].component
            let extraData = config[data.id].data !== undefined ? config[data.id].data : {}

            // Définition de l'id de la section
            let target = config[data.id].elementId
            if (config[data.id].dynamicPosition === true && data.zones[0].data.position > 1) {
                target = config[data.id].elementId + '_' + data.zones[0].data.position
            }
            let targetNode = document.getElementById(target)

            if (config[data.id].orchestrator !== undefined) {
                config[data.id].orchestrator(data)
            } else {
                // Données d'environnement
                const env = { 
                    pageId: window.dataStoreHP.pageId, 
                    isLogged: window.dataStoreHP.isLogged, 
                    device: window.dataStoreHP.device 
                }
                // Rendu
                if (targetNode !== null) {
                    render(<Component {...data.zones[0].data} eventId={data.id} {...extraData} {...env}/>, targetNode)
                } else {
                    throw (`La section #${targetNode} n'existe pas dans la page`)
                }
            }
        } else {
            // Avec Signal
            if (config[data.id].state !== undefined) {
                let value = {}
                value[data.zones[0].id] = data.zones[0].data
                config[data.id].state.value = value
            }
        }
    } catch (error) {
        console.error(`Generic orchestrator de ${data.id} : `, error)
        SG1Logs.incLog('Err_CORCH')
        SG1Logs.sentryEvent({ error: error, data: data, name: 'Generic Orchestrator' })
    }
}
